<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="系统日志详情" v-if="mdl">
        <detail-list-item term="模块">{{ mdl.model }}</detail-list-item>
        <detail-list-item term="终端编号">{{ mdl.terminalCode }}</detail-list-item>
        <detail-list-item term="发生时间">{{mdl.createTime | formatDate}}</detail-list-item>
        <detail-list-item term="事件">{{ mdl.action }}</detail-list-item>
        <detail-list-item term="日志类型">{{ mdl.typeName }}</detail-list-item>
        <detail-list-item term="发送通知次数">{{ mdl.send }}</detail-list-item>
        <detail-list-item term="请求路径">{{ mdl.actionUrl }}</detail-list-item>
        <detail-list-item term="备注">{{mdl.remark}}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-LogDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



